import {Component,OnInit,ViewChild} from '@angular/core';
import {FormulaireFactureService} from "@components/admin/parametre/formulaire/formulaire-facture/formulaire-facture.service";
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {NgForm} from "@angular/forms";

/**
 * Composant d'affichage de la page formulaire pour la facture
 *
 * @author Lionel Gimenez
 * @date 25/09/2025
 */
@Component({
    host: {'data-test-id': 'formulaire-facture'},
    selector: 'formulaire-facture',
    templateUrl: './formulaire-facture.component.html'
})
export class FormulaireFactureComponent implements OnInit {
    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /** Formulaire */
    @ViewChild('form') form: NgForm;

    /**
     * Constructeur
     */
    constructor(
        public formulaireFactureService: FormulaireFactureService,
    ) {
    }

    /**
     * Initialisation
     */
    ngOnInit(): void {
        //Chargement des données
        this.formulaireFactureService.load();

        //Initialisation des actions possibles
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-sauvegarde',
            libelle: 'global.actions.enregistrer',
            doAction: () => this.formulaireFactureService.save(),
            isDisabled: () => !this.form?.valid,
        }]);
    }
}
